<div class="main">
    <header></header>
    <div [ngClass]= '(localStorageService.get("authorized") !== null || router.url === "/faq") && !router.url.includes("footer-pages") ? "body--logged-in" : ""' class="body">
        <router-outlet></router-outlet>
    </div>
    <footer></footer>
</div>
<atram-loader></atram-loader>